export const saveAuthData = (response) => {
  if (response?.token?.accessToken) {
    localStorage.setItem("authToken", response?.token?.accessToken);
    localStorage.setItem("operatorId", response?.operatorId);
  }

  if (response?.data) {
    localStorage.setItem("userData", JSON.stringify(response.data));
  }
};

export const clearAuthData = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("userData");
  localStorage.removeItem("reddybook.multimarket.bookmarks.v1");
  // window.location.href = "/";
};
  
  export const isAuthenticated = () => {
    const token = localStorage.getItem("authToken") || localStorage.getItem("auth_token");
    return !!token;
  };
  
  export const getAuthToken = () => {
    return localStorage.getItem("authToken");
  };
  
  export const getUserData = () => {
    const userData = localStorage.getItem("userData");
    return userData ? JSON.parse(userData) : null;
  };
  